import { render, staticRenderFns } from "./MoveYellowBucketList.vue?vue&type=template&id=7298906c&scoped=true&"
import script from "./MoveYellowBucketList.vue?vue&type=script&lang=js&"
export * from "./MoveYellowBucketList.vue?vue&type=script&lang=js&"
import style0 from "./MoveYellowBucketList.vue?vue&type=style&index=0&id=7298906c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7298906c",
  null
  
)

export default component.exports